/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Filter } from './Filter';
import {
    FilterFromJSON,
    FilterFromJSONTyped,
    FilterToJSON,
} from './Filter';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
} from './PaginationInfo';

/**
 * 
 * @export
 * @interface FilterPagination
 */
export interface FilterPagination {
    /**
     * 
     * @type {Array<Filter>}
     * @memberof FilterPagination
     */
    data?: Array<Filter>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof FilterPagination
     */
    meta?: PaginationInfo;
}

/**
 * Check if a given object implements the FilterPagination interface.
 */
export function instanceOfFilterPagination(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FilterPaginationFromJSON(json: any): FilterPagination {
    return FilterPaginationFromJSONTyped(json, false);
}

export function FilterPaginationFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterPagination {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FilterFromJSON)),
        'meta': !exists(json, 'meta') ? undefined : PaginationInfoFromJSON(json['meta']),
    };
}

export function FilterPaginationToJSON(value?: FilterPagination | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FilterToJSON)),
        'meta': PaginationInfoToJSON(value.meta),
    };
}

